import React from 'react'
import styled from 'styled-components'
import { maxScreenWidth } from 'ui/StyledComponents/MediaBreakpoints'
import FeatureCard from './FeatureCard'

const SectionContainer = styled.section`
	padding-top: 0;
	padding-bottom: 8vh;
	scroll-margin: 112px;
`
const FeatureRow = styled.div`
	width: 100%;
	position: relative;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: ${(props) => (props.isEvenRow ? 'flex-start' : 'flex-end')};
	flex-grow: 1;
`

const FeatureIllustration = styled.div`
	position: absolute;
	${(props) => (props.isEvenRow ? 'right' : 'left')}: -25vw;

	img {
		max-width: 1045px;
		max-height: 1000px;
	}

	@media screen and (max-width: ${maxScreenWidth.phone}px) {
		display: none;
	}
`

function FeatureIntroduction({ featureGroups, scrollToRef, flip }) {
	const renderFeatureRow = (group, index) => {
		const isEvenRow =
			index % 2 === 0 ? (flip ? false : true) : flip ? true : false
		return (
			<FeatureRow key={index} isEvenRow={isEvenRow}>
				<FeatureCard title={group.title} features={group.features} />
				<FeatureIllustration isEvenRow={isEvenRow}>
					<img
						alt="Illustraatio"
						src={group.illustration}
						style={group.illustrationStyles}
					/>
				</FeatureIllustration>
			</FeatureRow>
		)
	}

	return (
		<SectionContainer ref={scrollToRef}>
			{featureGroups && featureGroups.map(renderFeatureRow)}
		</SectionContainer>
	)
}

export default FeatureIntroduction
